import { fetchAllPages } from './crm/CrmApiRepository.js';
import { GoalsApiService } from './crm/GoalsApiService.js';
import { mapGoalFromApi, mapGoalToApi } from './crm/ApiEntityMapper.js';
import { generateId, nowIso } from '../utils/IdUtils.js';
import { AuditService } from './AuditService.js';
import { auth } from './AuthService.js';
import { GOAL_REGISTRY } from '../constants/GoalRegistry.js';

export const MONTH_LABELS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export class GoalService {
  static async getAll() {
    const rows = await fetchAllPages('/api/v1/goals');
    return rows.map(mapGoalFromApi);
  }
  static async getById(id){ const all=await GoalService.getAll(); return all.find(g=>g.id===id)||null; }
  static async getForUser(userId,year){ const all=await GoalService.getAll(); return all.filter(g=>g.userId===userId&&g.year===year); }
  static async getForUserMonth(userId,year,month){ const all=await GoalService.getAll(); return all.filter(g=>g.userId===userId&&g.year===year&&g.month===month); }
  static async getForUserQuarter(userId,year,quarter){ const all=await GoalService.getAll(); return all.filter(g=>g.userId===userId&&g.year===year&&g.quarter===quarter); }
  // Deprecated: now server is single source. Keep stub for fallback.
  static async calculateAchieved(goal){ return Number(goal.achievedValue)||0; }
  static async save(goal){
    const session=auth.getSession(); const ts=nowIso();
    const prev=goal.id? await GoalService.getById(goal.id):null;
    const reg=GOAL_REGISTRY[goal.goalType] || GOAL_REGISTRY.revenue;
    const year=Number(goal.year)||new Date().getFullYear();
    const record={
      id: goal.id||generateId('goal'),
      userId: reg.scope==='organization'? null : goal.userId,
      scope: reg.scope,
      goalName: goal.goalName||'',
      goalType: goal.goalType||'revenue',
      period: goal.period||'yearly',
      year, month: goal.month!=null?Number(goal.month):0, quarter: goal.quarter!=null?Number(goal.quarter):0,
      targetValue: Number(goal.targetValue)||0,
      achievedValue: Number(goal.achievedValue)||0,
      unitType: reg.unit,
      currency: goal.currency||'INR',
      status: goal.status||'active',
      description: goal.description||'',
      startDate: goal.startDate||`${year}-01-01`,
      endDate: goal.endDate||`${year}-12-31`,
      createdBy: prev?.createdBy||goal.createdBy||session?.userId||null,
      updatedBy: session?.userId||goal.updatedBy||null,
      createdAt: prev?.createdAt||goal.createdAt||ts,
      updatedAt: ts
    };
    // Let server compute auto progress; for new goals try server progress fetch after create
    if(!goal.id){
      const saved=await GoalsApiService.create(mapGoalToApi(record));
      const mapped=mapGoalFromApi(saved?.data||saved);
      if(mapped?.id) Object.assign(record,mapped);
      // fetch server computed progress if auto
      if(reg.auto){ try{ const prog=await GoalsApiService.progress(record.id); if(prog?.data?.achieved!=null) record.achievedValue=Number(prog.data.achieved);}catch{} }
    } else {
      try{ const saved=await GoalsApiService.update(record.id, mapGoalToApi(record)); const mapped=mapGoalFromApi(saved?.data||saved); if(mapped?.id) Object.assign(record,mapped);}catch{}
    }
    if(prev) await AuditService.logFieldChanges({entityType:'goal',entityId:record.id,action:'goal.fields_changed',before:prev,after:record,fields:['goalName','targetValue','status']});
    else await AuditService.log({entityType:'goal',entityId:record.id,action:'goal.created',after:{goalName:record.goalName,targetValue:record.targetValue}});
    window.dispatchEvent(new CustomEvent('goalSaved',{detail:{goal:record}}));
    return record;
  }
  static async saveMonthly(goal){ return GoalService.save({...goal, period:'monthly'}); }
  static async saveQuarterly(goal){ return GoalService.save({...goal, period:'quarterly'}); }
  static async delete(id){ try{await GoalsApiService.remove(id);}catch{} await AuditService.log({entityType:'goal',entityId:id,action:'goal.disabled',before:{status:'active'},after:{status:'inactive'}}); }
  static async recalculateAll(){ return GoalService.getAll(); }
}
